export default {"src":"/fi/sahkoa/_next/static/media/brandLogo.5579e98f.svg","height":142,"width":602,"blurWidth":0,"blurHeight":0};